var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 162,
    viewBox: "0 0 150 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 6092"
  }, /*#__PURE__*/React.createElement("g", {
    id: "success_icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 6080"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 35",
    d: "M123.651 86.7775C123.651 114.258 101.329 136.535 73.792 136.535C46.2554 136.535 23.9326 114.258 23.9326 86.7775C23.9326 59.2969 46.2554 37.0195 73.792 37.0195C101.329 37.0195 123.651 59.2969 123.651 86.7775Z",
    fill: "#0DA814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M57.3945 87.5941L66.7646 96.5944L90.1897 78.5938",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 150",
    opacity: 0.55,
    cx: 123.652,
    cy: 133.548,
    rx: 2.99156,
    ry: 2.98548,
    fill: "#008800"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 155",
    opacity: 0.55,
    cx: 7.97789,
    cy: 96.7277,
    rx: 2.99156,
    ry: 2.98548,
    fill: "#008800"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 151",
    opacity: 0.55,
    cx: 4.98594,
    cy: 66.8742,
    rx: 4.98594,
    ry: 4.97579,
    fill: "#008800"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 152",
    opacity: 0.55,
    cx: 137.612,
    cy: 60.9025,
    rx: 3.98875,
    ry: 3.98064,
    fill: "#008800"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 153",
    opacity: 0.55,
    cx: 115.674,
    cy: 24.0803,
    rx: 5.98312,
    ry: 5.97095,
    fill: "#008800"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 154",
    opacity: 0.55,
    cx: 51.8542,
    cy: 153.451,
    rx: 5.98312,
    ry: 5.97095,
    fill: "#008800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 79",
    opacity: 0.55,
    d: "M73.5537 21.543L73.7148 11.095L64.7412 10.9572L64.8792 2.00188",
    stroke: "#008800",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 80",
    opacity: 0.55,
    d: "M19.71 128.32L12.7219 127.342L11.4748 136.211L5.48504 135.373",
    stroke: "#008800",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 82",
    opacity: 0.55,
    d: "M148 93.8945L141.063 92.6023L139.416 101.407L133.471 100.299",
    stroke: "#008800",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 81",
    opacity: 0.55,
    d: "M92.6621 145.91L91.7844 152.898L100.689 154.012L99.937 160.001",
    stroke: "#008800",
    strokeWidth: 4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 56",
    opacity: 0.55,
    x1: 2,
    y1: -2,
    x2: 16.9344,
    y2: -2,
    transform: "matrix(0.82852 0.55996 -0.561525 0.827459 9.97168 32.043)",
    stroke: "#008800",
    strokeWidth: 4,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTick);
export default __webpack_public_path__ + "static/media/green_tick.9d68f9fd549ce332d7f839623154efd7.svg";
export { ForwardRef as ReactComponent };